/**
 * Convert markdown bot replies into plain text safe for TTS.
 *
 * The chat bubble renders the original markdown via ReactMarkdown, so this
 * MUST NOT be applied to text shown in the UI — only to the string passed
 * into `anamClient.talk(...)` so Anam doesn't read "asterisk asterisk
 * Certificates", URLs, or emoji names out loud.
 */
export function sanitizeForAvatarSpeech(input: string): string {
  let s = input;

  // Markdown links: [label](url) -> label. Must run BEFORE the bare-URL
  // strip so the inner URL doesn't shrink the parens away first.
  s = s.replace(/\[([^\]]+)\]\((?:[^)]+)\)/g, '$1');
  // Markdown images: ![alt](url) -> alt
  s = s.replace(/!\[([^\]]*)\]\((?:[^)]+)\)/g, '$1');
  // Bare URLs (http/https/www) -> drop entirely
  s = s.replace(/\bhttps?:\/\/\S+/gi, '');
  s = s.replace(/\bwww\.\S+/gi, '');

  // Code fences: keep inner text, drop the ``` markers.
  s = s.replace(/```[\s\S]*?```/g, (m) => m.replace(/```/g, ''));
  s = s.replace(/`([^`]+)`/g, '$1');

  s = s.replace(/(\*\*|__)(.*?)\1/g, '$2');
  s = s.replace(/(\*|_)(.*?)\1/g, '$2');
  s = s.replace(/~~(.*?)~~/g, '$1');

  // Headings (#, ##, ...) and blockquotes (>) at line start
  s = s.replace(/^\s{0,3}#{1,6}\s+/gm, '');
  s = s.replace(/^\s{0,3}>\s?/gm, '');

  // List markers at line start: "* ", "- ", "+ ", "1. "
  s = s.replace(/^\s*[*+-]\s+/gm, '');
  s = s.replace(/^\s*\d+\.\s+/gm, '');

  s = s.replace(/\p{Extended_Pictographic}/gu, '');

  s = s.replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim();
  return s;
}
